import {useDispatch} from "react-redux";
import {useMemo} from "react";
import {bindActionCreators} from "@reduxjs/toolkit";
import {scrollPositionActions} from "../store/slices/scrollPosition.slice";

export function useScrollPositionActions() {
    const dispatch = useDispatch()

    return useMemo(() =>
        bindActionCreators(scrollPositionActions, dispatch), [dispatch])
}